module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9bc717fc42785b5bd4c5d5846ab18118.png";